/**
 * Call Datalayer
 *
 * Call datalayer you need register this like above, so you can call this with the next function when the event is clic
 *      dataDataLayers('name-selected', 'label-without-encrypt'), for example
 *      dataDataLayers('startGame', 'davidfmb93@gmail.com')
 */
declare global {
  interface Window {
    dataLayer: any;
  }
}

export const datalayers = async () => {
  //datalayer internas sabores btn comprar
  let btnInternaShop = document.querySelector(
    ".mxmhboxDetail__body__top__content__right--content a"
  ) as any;
  if (btnInternaShop) {
    let pathname = window.location.pathname;
    btnInternaShop.addEventListener("click", function (e: any) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "Michelob Seltzer Equity",
        eventAction: "Comprar - Caracteristicas Producto",
        eventLabel: pathname,
      });
    });
  }

  //datalayer internas sabores btn video
  let btnInternaVideo = document.querySelector(
    ".mxmhboxDetail__body__bottom--content--right a"
  ) as any;
  if (btnInternaVideo) {
    let pathname = window.location.pathname;
    btnInternaVideo.addEventListener("click", function (e: any) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "Michelob Seltzer Equity",
        eventAction: "Comprar - Video",
        eventLabel: pathname,
      });
    });
  }

  //datalayer user area btn ver ranking
  let btnviewRanking = document.querySelector(
    ".mxmhboxuserArea__top__content--right a"
  );
  if (btnviewRanking) {
    btnviewRanking.addEventListener("click", function (e: any) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "Michelob Seltzer Equity",
        eventAction: "Ranking - Inicio de sesión",
        eventLabel: "Clic",
      });
    });
  }

  //datalayer user area card trivia
  let btncardTrivia = document.querySelector(
    ".mxmhboxuserArea__top__bottom--left__content .btntrivia"
  );
  if (btncardTrivia) {
    btncardTrivia.addEventListener("click", function (e: any) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "Michelob Seltzer Equity",
        eventAction: "Trivia - Inicio de sesión",
        eventLabel: "Clic",
      });
    });
  }

  //datalayer user area card juego
  let btncardGame = document.querySelector(
    ".mxmhboxuserArea__top__bottom--right__content .btnplay"
  );
  if (btncardGame) {
    btncardGame.addEventListener("click", function (e: any) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "Michelob Seltzer Equity",
        eventAction: "Ultra Jump - Inicio de sesión",
        eventLabel: "Clic",
      });
    });
  }

  //datalayer ver todas las recetas
  let backRecipe = document.querySelector(".mxmhRecipes__content--allRecipes");
  if (backRecipe) {
    backRecipe.addEventListener("click", function (e: any) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "Michelob Seltzer Equity",
        eventAction: "Sección Recetas - Ver todas las recetas",
        eventLabel: "Clic",
      });
    });
  }

  //datalayer clickReceta
  let clickRecetas = document.querySelectorAll(".listRecipes");
  if (clickRecetas) {
    Array.from(clickRecetas).map((clickReceta) => {
      clickReceta.addEventListener("click", function (e: any) {
        const title = clickReceta.querySelector(".listRecipes--title");
        if (title) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "trackEvent",
            eventCategory: "Michelob Seltzer Equity",
            eventAction: "Sección Recetas",
            eventLabel: title.innerHTML,
          });
        }
      });
    });
  }
};
